module.exports = {
  login: '/elearn/api/login',
  logout: '/elearn/api/logout',
  forgot: '/elearn/api/forgot-password',
  _getprofile: '/elearn/api/user/profile',
  changepass: '/elearn/api/user/change-password',
  updateprofile: '/elearn/api/user/update-profile',
  resetpass: '/elearn/api/reset-password',
};
